<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,782.5c5.51,0,10,4.49,10,10s-4.49,10-10,10s-10-4.49-10-10S-5.01,782.5,0.5,782.5z M0.5,784.5c-4.43,0-8,3.56-8,8
	s3.57,8,8,8s8-3.57,8-8S4.93,784.5,0.5,784.5L0.5,784.5z M0.5,787.5l1.47,2.98l3.29,0.48l-2.38,2.32l0.56,3.27L0.5,795l-2.94,1.54
	l0.56-3.27l-2.38-2.32l3.29-0.48L0.5,787.5z"/>
</svg>

</template>